import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-ag-modal-container',
  templateUrl: './ag-modal-container.component.html',
  styleUrls: ['./ag-modal-container.component.scss'],
})
export class AgModalContainerComponent {
  @Output() clickClose = new EventEmitter();

  closeModal(): void {
    this.clickClose.emit();
  }
}
